<template>
  <div class="index">
    <div class="index-header" :style="{height: headerHeight+'px'}">
       <div class="index-future">Non-custodial<br>staking infrastructure</div>
<!--      <div class="cube" :style="{'transition': transition, 'transform': 'rotateX(' + rotateArr[index % 4] + 'deg) rotateY(' + rotateY + 'deg)'}">
        <div class="side front"></div>
        <div class="side back"></div>
        <div class="side right"></div>
        <div class="side left"></div>
        <div class="side top"></div>
        <div class="side bottom"></div>
      </div>-->
    </div>
    <div class="staking-services">
      <div class="staking-services-stip">
        <h3>Staking services</h3>
        <p>Proof of Stake token holders can earn yield through our non-custodial staking services.</p>
        <span @click="toUrl('/how-it-works')">How it works <i class="fa fa-angle-right" aria-hidden="true"></i></span>
      </div>
      <div class="staking-list">
        <ul>
          <li v-for="(item, index) in stakingList" :key="index" @click="toUrl(item.url)" :style="{'margin-left': index % stakingListIndex == 1 ? '2%' : 0, 'margin-right': index % stakingListIndex == 1 ? '2%' : 0}">
            <div class="staking-list-coin">
              <img :src="'../../../static/images/svg/'+item.img_name +'.svg'" alt="">
              <div>
                <p>{{item.staking_name}}</p>
                <span>{{item.coin_type}}</span>
              </div>
            </div>
           <span class="staking-list-coin-yield" v-if="item.staking_name=='Terra Classic'">N/A</span>
           <span class="staking-list-coin-yield" v-else>{{item.current_rewards}}%</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="staking-choose">
      <div class="staking-choose-list">
        <h3>Why choose us?</h3>
        <ul>
          <li>· Non-custodial</li>
          <li>· High security</li>
          <li>· Aligned incentives</li>
          <li>· Community contributions</li>
        </ul>
      </div>
      <div class="staking-choose-msg">
        <div class="staking-choose-msg-box">
          <div>
            <span><i>●</i><i>●</i><i>●</i></span>
          </div>
          <ul>
            <li><img src="../../static/images/index/manage.svg" alt=""><p>We do not custody your assets. You <span style="border-left: 1px solid #2E9728;">have<b style="display: block;">Non-custodial</b><i style="display: block;"></i></span> the full control.</p></li>
            <li><img src="../../static/images/index/umbrella.svg" alt=""><p>The security of your stake is <span>of<b>High security</b><i></i></span> utmost importance to us.</p></li>
            <li><img src="../../static/images/index/award.svg" alt=""><p>We stake our own crypto assets on our <span>validators<b>Aligned incentives</b><i></i></span>, taking aligned rewards and risk with you.</p></li>
            <li><img src="../../static/images/index/share.svg" alt=""><p>We payback the profit to the <span>crypto<b>Community contributions</b><i></i></span> community via the faucet system available to more than 3 millions users.</p></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="staking-mission">
      <h3>The Mission: Build a sustainable future</h3>
      <p>We believe that the future of the earth must not be at the expense of the environment. This is why we are continuously building infrastures for Proof of Stake blockchains.</p>
      <span @click="toUrl('/mission')">Learn more <i class="fa fa-angle-right" aria-hidden="true"></i></span>
    </div>
    <div class="staking-bottom-bg"></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      transition: 'all 2s',
      headerHeight: 996,
      timer: null,
      rotateArr: [0, -20, 0, 20],
      rotateY: 0,
      index: 0,
      stakingListIndex: 3
    }
  },
  computed: {
    stakingList () {
      return this.$store.getters.indexCoinMsg
    }
  },
  created () {
    if ($(window).width() <= 700) {
      this.headerHeight = 400
    } else {
      this.headerHeight = $(window).height() - 90
    }
    $(window).resize(() => {
      if ($(window).width() <= 700) {
        this.headerHeight = 400
      } else {
        this.headerHeight = $(window).height() - 90
      }
    })
  },
  mounted () {
    $('.staking-choose-list li').mouseenter(function () {
      $('.staking-choose-msg-box li span').css({border: 0})
      $('.staking-choose-msg-box li b').hide().siblings('i').hide()
      $('.staking-choose-msg-box li').eq($(this).index()).find('span').css({'border-left': '1px solid #2E9728'}).find('b').show().siblings('i').show()
    })
    document.addEventListener('visibilitychange', this.monitor)
    this.timer = setInterval(() => {
      this.rotateY -= 45
      this.index += 1
      // $('.cube').css({'transform': 'rotateX(' + this.rotateArr[this.index % 4] + 'deg) rotateY(' + this.rotateY + 'deg)'})
    }, 2000)
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  destroyed () {
    document.removeEventListener('visibilitychange', this.monitor)
  },
  methods: {
    toUrl: function (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    monitor: function (e) {
      let isExist = e.target.visibilityState
      if (isExist === 'visible') {
        this.transition = 'all 2s'
        this.timer = setInterval(() => {
          this.rotateY -= 45
          this.index += 1
          // $('.cube').css({'transform': 'rotateX(' + this.rotateArr[this.index % 4] + 'deg) rotateY(' + this.rotateY + 'deg)'})
        }, 2000)
      } else {
        clearInterval(this.timer)
        // $('.cube').css({'transition': 'none'})
        // this.transition = 'none'
        // this.index = 0
        // this.rotateY = 0
        // $('.cube').css({'transform': 'rotateX(0deg) rotateY(0)'})
      }
    }
  }
}
</script>

<style scoped>
.cube {
   width: 600px;
   height: 600px;
  /*设置3d场景*/
  transform-style: preserve-3d;
  position: relative;
  /* transition: all 2s; */
}
/*为第一面设置一些简单的样式*/
.side {
  position: absolute;
  width: 600px;
  height: 600px;
  color: white;
  overflow: hidden;
  backface-visibility: hidden;
}
/*移动第一面到相应的位置*/
.front {
  transform: translateZ(300px);
  background: url('../../static/images/02.png') no-repeat;
  background-size: 100% 100%;
}
.bottom {
  transform: rotateX(-90deg) translateZ(300px);
  background: url('../../static/images/01.png') no-repeat;
  background-size: 100% 100%;
}
.top {
  transform: rotateX(90deg) translateZ(300px);
  background: url('../../static/images/01.png') no-repeat;
  background-size: 100% 100%;
}
.left {
  transform: rotateY(-90deg) translateZ(300px);
  background: url('../../static/images/05.png') no-repeat;
  background-size: 100% 100%;
}
.right {
  transform: rotateY(90deg) translateZ(300px);
  background: url('../../static/images/03.png') no-repeat;
  background-size: 100% 100%;
}
.back {
  transform: rotateY(180deg) translateZ(300px);
  background: url('../../static/images/04.png') no-repeat;
  background-size: 100% 100%;
}
.index{
  background-color: #FFFFFF;
}
.index-header{
  background-color: #171A17;
  display: flex;
  align-items: center;
  justify-content: center;
}
.index-future{
  /*width: 100%;
  font-size: 160px;
  font-family: 'FRAHV';
  font-weight: 400;
  color: #1E221E;
    text-shadow: -2px 0px 1px #3c3f3c, 0px 2px 1px #000000;
  text-align: center;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);*/
  width: 100%;
  font-size: 100px;
  font-family: 'FRAHV';
  font-weight: 400;
  color: #2E9728;
  text-shadow: 0px 2px 1px #000000;
  text-align: center;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.staking-services{
  max-width: 1400px;
  width: 100%;
  padding: 240px 20px 0 20px;
  display: flex;
  align-items: center;
  margin: 0 auto;
}
.staking-services-stip{
  flex: 1;
}
.staking-services-stip h3{
  font-size: 46px;
  font-family: 'FRAHV';
  font-weight: 400;
  color: #303030;
  text-shadow: 0px 2px 2px #A9A9A9;
}
.staking-services-stip p{
  font-size: 18px;
  font-family: 'PingFangSC-Medium';
  font-weight: 500;
  color: #535353;
  margin: 20px 0;
}
.staking-services-stip span{
  font-size: 18px;
  font-family: 'PingFangSC-Medium';
  font-weight: 500;
  color: #2E9728;
  cursor: pointer;
}
.staking-services-stip span i{
  margin-left: 10px;
}
.staking-list{
  width: 970px;
  padding: 0 10px;
  max-height: 532px;
  overflow-x: hidden;
  overflow-y: auto;
  margin-left: 30px;
}
.staking-list::-webkit-scrollbar{
  width:8px;
  height:8px;
  background-color: #A0D5A0;
}
.staking-list::-webkit-scrollbar-track{
    background: #F5FAF5;
}
.staking-list::-webkit-scrollbar-thumb{
    background: #A0D5A0;
    border-radius:4px;
}
.staking-list::-webkit-scrollbar-thumb:hover{
    background: #A0D5A0;
}
.staking-list::-webkit-scrollbar-corner{
    background: #A0D5A0;
}
.staking-list ul {
  padding: 10px 0;
  display: flex;
  flex-wrap: wrap;
}
.staking-list ul li{
  width: 32%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  background: #FFFFFF;
  box-shadow: 0px 1px 6px 0px #D8D8D8;
  border-radius: 54px;
  margin-bottom: 27px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}
.staking-list ul li:hover{
   box-shadow: 0px 1px 24px 0px #D8D8D8;
}
.staking-list-coin{
  display: flex;
  align-items: center;
}
.staking-list ul li img{
  width: 62px;
  height: 62px;
}
.staking-list-coin div{
  margin: 0 20px;
}
.staking-list-coin div p{
  font-size: 18px;
  font-family: 'FRAHV';
  font-weight: 400;
  color: #303030;
  line-height: 28px;
}
.staking-list-coin div span{
  font-size: 16px;
  font-family: 'FRAHV';
  font-weight: 400;
  color: #777777;
}
.staking-list-coin-yield{
  font-size: 20px;
  font-family: 'FRAHV';
  font-weight: 400;
  color: #3EA338;
}
.staking-choose{
  max-width: 1300px;
  width: 100%;
  margin: 300px auto;
  padding: 0 20px;
  display: flex;
  flex-direction:row-reverse;
  justify-content: space-between;
}
.staking-choose-msg{
  width: 582px;
  height: 710px;
  background: #F3F3F3;
  box-shadow: 6px 6px 21px 0px #D6D6D6, 0px 6px 5px 0px #F3F3F3, 2px 0px 5px 5px #fdfdfd inset;
  border-radius: 40px;
  padding: 30px;
}
.staking-choose-msg .staking-choose-msg-box{
  width: 100%;
  height: 100%;
  background: #363636;
  border-radius: 30px;
  padding: 15px 30px 30px 30px;
}
.staking-choose-msg .staking-choose-msg-box div{
  margin-bottom: 80px;
}
.staking-choose-msg .staking-choose-msg-box div span{
  font-size: 30px;
  color: #499445;
}
.staking-choose-msg .staking-choose-msg-box ul li{
  font-size: 14px;
  /* font-family: 'PingFangSC-Medium'; */
  font-weight: 400;
  color: #D6D6D6;
  display: flex;
  margin-bottom: 30px;
}
.staking-choose-msg .staking-choose-msg-box ul li p span{
  position: relative;
}
.staking-choose-msg .staking-choose-msg-box ul li p span b{
  position: absolute;
  white-space: nowrap;
  padding: 10px;
  background: #2E9728;
  left: -55px;
  top: -60px;
  z-index: 2;
  display: none;
}
.staking-choose-msg .staking-choose-msg-box ul li p span i{
    position: absolute;
    width: 10px;
    height: 10px;
    background: #2E9728;
    left: -6px;
    top: -26px;
    transform: rotateZ(45deg);
    display: none;
}
.staking-choose-msg .staking-choose-msg-box ul li img{
  width: auto;
  height: 16px;
  margin-right: 10px;
  margin-top: 4px;
}
.staking-choose-list{
  margin-top: 150px;
}
.staking-choose-list h3{
  font-size: 56px;
  font-family: 'FRAHV';
  font-weight: 400;
  color: #303030;
  text-shadow: 0px 2px 2px #A5AAA5;
}
.staking-choose-list ul{
  display: flex;
  flex-wrap: wrap;
  width: 480px;
  margin-top: 50px;
}
.staking-choose-list ul li{
  font-size: 20px;
  font-family: 'PingFangSC-Medium';
  font-weight: 500;
  color: #303030;
  margin-bottom: 30px;
  margin-right: 20px;
  cursor: pointer;
}
.staking-choose-list ul li:hover{
  color: #2E9728;
}
.staking-mission{
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  padding: 0 20px;
}
.staking-mission h3{
  font-size: 50px;
  font-family: 'FRAHV';
  font-weight: 400;
  color: #303030;
  text-shadow: 0px 2px 2px #A5AAA5;
}
.staking-mission p{
  max-width: 730px;
  width: 100%;
  text-align: center;
  font-size: 18px;
  font-family: 'PingFangSC-Medium';
  font-weight: 500;
  color: #535353;
  margin: 30px auto;
}
.staking-mission span{
  font-size: 18px;
  font-family: 'PingFangSC-Medium';
  font-weight: 500;
  color: #2E9728;
  cursor: pointer;
}
.staking-mission span i{
  margin-left: 5px;
}
.staking-bottom-bg{
  width: 100%;
  height: 650px;
  background: url('../../static/images/index/bg.png') no-repeat;
  background-size: 100% 100%;
}
@media (max-width: 1200px) {
  .cube,.side{
    width: 500px;
    height: 500px;
  }
  .front {
    transform: translateZ(250px);
    background: url('../../static/images/02.png') no-repeat;
    background-size: 100% 100%;
  }
  .bottom {
    transform: rotateX(-90deg) translateZ(250px);
    background: url('../../static/images/01.png') no-repeat;
    background-size: 100% 100%;
  }
  .top {
    transform: rotateX(90deg) translateZ(250px);
    background: url('../../static/images/01.png') no-repeat;
    background-size: 100% 100%;
  }
  .left {
    transform: rotateY(-90deg) translateZ(250px);
    background: url('../../static/images/05.png') no-repeat;
    background-size: 100% 100%;
  }
  .right {
    transform: rotateY(90deg) translateZ(250px);
    background: url('../../static/images/03.png') no-repeat;
    background-size: 100% 100%;
  }
  .back {
    transform: rotateY(180deg) translateZ(250px);
    background: url('../../static/images/04.png') no-repeat;
    background-size: 100% 100%;
  }
  .index-future{
    font-size: 65px;
  }
  .staking-list{
    max-width: 700px;
    width: 100%;
  }
  .staking-services{
    padding-top: 180px;
  }
  .staking-choose{
    margin: 180px auto;
  }
  .staking-list ul li{
    width: 45%;
    margin-left: 2% !important;
    margin-right: 0 !important;
  }
  .staking-list ul li img{
    width: 60px;
    height: 60px;
  }
  .staking-list-coin div p{
    font-size: 18px;
  }
  .staking-services-stip h3,.staking-choose-list h3,.staking-mission h3{
    font-size: 40px;
  }
  .staking-services-stip p,.staking-mission p{
    font-size: 16px;
  }
  .staking-services-stip span.staking-mission span{
    font-size: 16px;
  }
  .staking-choose-list ul li{
    font-size: 18px;
  }
  .staking-choose-msg{
    max-width: 540px;
    width: 100%;
    height: 650px;
    margin-right: 40px;
  }
  .staking-bottom-bg{
    height: 380px;
  }
}
@media (max-width: 960px) {
  .cube,.side{
    width: 300px;
    height: 300px;
  }
  .front {
    transform: translateZ(150px);
    background: url('../../static/images/02.png') no-repeat;
    background-size: 100% 100%;
  }
  .bottom {
    transform: rotateX(-90deg) translateZ(150px);
    background: url('../../static/images/01.png') no-repeat;
    background-size: 100% 100%;
  }
  .top {
    transform: rotateX(90deg) translateZ(150px);
    background: url('../../static/images/01.png') no-repeat;
    background-size: 100% 100%;
  }
  .left {
    transform: rotateY(-90deg) translateZ(150px);
    background: url('../../static/images/05.png') no-repeat;
    background-size: 100% 100%;
  }
  .right {
    transform: rotateY(90deg) translateZ(150px);
    background: url('../../static/images/03.png') no-repeat;
    background-size: 100% 100%;
  }
  .back {
    transform: rotateY(180deg) translateZ(150px);
    background: url('../../static/images/04.png') no-repeat;
    background-size: 100% 100%;
  }
  .staking-services{
    display: block;
  }
  .staking-services-stip{
    text-align: center;
  }
  .staking-list{
    margin: 20px auto;
  }
  .staking-services{
    padding-top: 100px;
  }
  .staking-choose{
    margin: 100px auto;
    display: block;
  }
  .staking-choose-list h3{
    text-align: center;
  }
  .staking-choose-list ul{
    margin: 30px auto;
  }
  .staking-choose-list ul li{
    width: 50%;
    margin-right: 0;
  }
  .staking-choose-msg{
    margin: 0 auto;
  }
  .index-future{
    padding: 0 50px;
  }
}
@media (max-width: 720px) {
  .cube,.side{
    width: 200px;
    height: 200px;
  }
  .front {
    transform: translateZ(100px);
    background: url('../../static/images/02.png') no-repeat;
    background-size: 100% 100%;
  }
  .bottom {
    transform: rotateX(-90deg) translateZ(100px);
    background: url('../../static/images/01.png') no-repeat;
    background-size: 100% 100%;
  }
  .top {
    transform: rotateX(90deg) translateZ(100px);
    background: url('../../static/images/01.png') no-repeat;
    background-size: 100% 100%;
  }
  .left {
    transform: rotateY(-90deg) translateZ(100px);
    background: url('../../static/images/05.png') no-repeat;
    background-size: 100% 100%;
  }
  .right {
    transform: rotateY(90deg) translateZ(100px);
    background: url('../../static/images/03.png') no-repeat;
    background-size: 100% 100%;
  }
  .back {
    transform: rotateY(180deg) translateZ(100px);
    background: url('../../static/images/04.png') no-repeat;
    background-size: 100% 100%;
  }
  .index-future{
    font-size: 40px;
  }
  .staking-list ul li img{
    width: 30px;
    height: 30px;
  }
  .staking-list-coin div p{
    font-size: 16px;
  }
  .staking-list-coin div span{
    font-size: 14px;
  }
  .staking-list-coin-yield{
    font-size: 16px;
  }
  .staking-choose-msg{
    height: 580px;
  }
}
@media (max-width: 634px) {
  .staking-list ul{
    display: block;
  }
  .staking-list ul li{
    width: 80%;
    margin: 15px auto !important;
  }
  .staking-services-stip h3,.staking-choose-list h3,.staking-mission h3{
    font-size: 30px;
  }
  .staking-choose-list{
    margin-top: 100px;
  }
  .staking-bottom-bg{
    height: 220px;
  }
  .staking-choose-list ul{
    width: 100%;
  }
  .staking-choose-msg .staking-choose-msg-box div span{
    font-size: 20px;
  }
  .staking-choose-msg .staking-choose-msg-box div{
    margin-bottom: 80px;
  }
  .staking-choose-msg .staking-choose-msg-box ul li{
    margin-bottom: 10px;
  }
  .staking-choose-msg{
    height: auto;
  }
  .index-future{
    font-size: 30px;
  }
}
@media (max-width: 360px) {
  .index-future{
    padding: 0 20px;
    font-size: 28px;
  }
  .staking-choose-msg{
    padding: 10px;
  }
  .staking-choose-msg .staking-choose-msg-box div{
    margin-bottom: 50px;
  }
  .staking-list ul li{
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue